import ACCOUNT_LIST from "./list";

export default ACCOUNT_LIST;
